import React from 'react'

export default function About() {
  return (
    <>
          <a href="#about" data-scroll-to>
            <h1>ABOUT ME</h1>
          </a>

          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perferendis, accusantium. Vero adipisci provident, necessitatibus error sequi officiis ut voluptate nihil illo impedit repellendus ea tempora itaque tempore dolor sed maxime!</p>
    
    </>
  )
}
